import { Controller } from "@hotwired/stimulus"
import $ from 'jquery'
import Cookies from 'js-cookie'

export default class extends Controller {
  static targets = ['checkbox']
  static values = {}

  connect() {
    $(this.element).foundation();
    $(this.element).foundation('open');
    $(this.element).on('closed.zf.reveal', ()=> this.onClose());
  }
  
  onClose() {
    let reminder = this.checkboxTarget.checked
    Cookies.set('setup-tfa-dismissed', 'true', {path: '/', expires: (reminder ? 3650 : null)})
  }
}